import React from 'react';
import { Icon } from '@iconify/react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts';
import Loader from '../../../components/common/Loader';
import NoData from '../../../components/common/NoData';

const formatChartData = (apiData) => {
  if (!apiData || !Array.isArray(apiData)) return [];

  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                     'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  return apiData.map(item => {
    const date = new Date(item.month + '-01');
    const monthIndex = date.getMonth();
    return {
      name: monthNames[monthIndex] || item.month,
      Courses: item.count || 0
    };
  });
};

function CourseGraph({ data = [], loading = false }) {
  const chartData = formatChartData(data);
  const hasRecords = chartData.some((item) => Number(item.Courses) > 0);
  return (
    <div className={"[&_>_.ui-card-header.permission-toolbar]:tw-sticky [&_>_.ui-card-header.permission-toolbar]:tw-top-[var(--permissions-header-offset,_0px)] [&_>_.ui-card-header.permission-toolbar]:tw-z-[10] [&_>_.ui-card-header.permission-toolbar]:[background:var(--bg-primary,_#fff)] [&_>_.ui-card-header.permission-toolbar]:tw-border-b-[1px] [&_>_.ui-card-header.permission-toolbar]:tw-border-solid [&_>_.ui-card-header.permission-toolbar]:tw-border-b-[var(--border-color,_#dee2e6)] [&_>_.ui-card-header.permission-toolbar]:[background-clip:border-box] [&_>_.ui-card-header.permission-toolbar]:tw-shadow-[0_3px_6px_rgba(0,_0,_0,_0.06)] [&.card-hover-primary:hover]:tw-border-[var(--primary-color)] [&.card-hover-success:hover]:tw-border-[var(--success-color)] [&.card-hover-danger:hover]:tw-border-[var(--danger-color)] [[data-theme='dark']_&]:tw-bg-[var(--bg-primary)] [[data-theme='dark']_&]:tw-border-[var(--border-color)] tw-shadow-[var(--tw-ring-offset-shadow,_0_0_#0000),_var(--tw-ring-shadow,_0_0_#0000),_var(--tw-shadow)] tw-border-solid tw-rounded-[0.75rem] [transition:all_0.3s_ease-in-out] tw-relative tw-flex tw-min-w-[0px] tw-flex-col tw-border-[1px] [--tw-border-opacity:1] tw-border-[rgb(226_232_240_/_var(--tw-border-opacity,_1))] [--tw-bg-opacity:1] tw-bg-[rgb(255_255_255_/_var(--tw-bg-opacity,_1))] [--tw-shadow:0_2px_8px_-4px_rgb(15_23_42_/_.12)] [--tw-shadow-colored:0_2px_8px_-4px_var(--tw-shadow-color)] ui-card tw-p-2"}>
      <h6 className="tw-mb-2 tw-flex tw-items-center tw-gap-2">
        <Icon icon="lucide:book-open" width="20" height="20" className="!tw-text-[var(--success-color)] tw-text-emerald-600" aria-hidden="true" />
        <span>Course Statistics (Monthly Adds)</span>
      </h6>
      {loading ? (
        <div className="tw-flex tw-justify-center tw-items-center" style={{ height: '260px' }}>
          <Loader />
        </div>
      ) : !hasRecords ? (
        <div className="tw-flex tw-min-h-[260px] tw-items-center tw-justify-center">
          <NoData message="No course statistics available yet" description="Monthly course activity will appear here when courses are added." />
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={260}>
          <BarChart
            data={chartData}
          barSize={24}
          margin={{ top: 10, right: 0, left: -10, bottom: -5 }}
        >
          <defs>
            <linearGradient id="courseGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#63d69f" />
              <stop offset="100%" stopColor="#198754" />
            </linearGradient>
          </defs>

          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="name" padding={{ left: 0, right: 0 }} stroke="#888" fontSize={12} />
          <YAxis allowDecimals={false} stroke="#888" fontSize={12} />
          <Tooltip />
          <Bar dataKey="Courses" fill="url(#courseGradient)" radius={[10, 10, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
      )}
    </div>
  );
}

export default CourseGraph;
